import Portfolio from "./components/Portfolio";

function App() {
  return (
    <div className="relative">
      <Portfolio />
    </div>
  );
}

export default App;
